import { render, staticRenderFns } from "./ProfitModule.vue?vue&type=template&id=572760e9&scoped=true"
import script from "./ProfitModule.vue?vue&type=script&lang=js"
export * from "./ProfitModule.vue?vue&type=script&lang=js"
import style0 from "./ProfitModule.vue?vue&type=style&index=0&id=572760e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572760e9",
  null
  
)

export default component.exports